import React from 'react';
import { faClock, faCalendarDays, faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';
import { Bold, Paragraph, YellowCircleIcon } from '../../Atoms';
import {
  getFormattedDateMultilanguage,
  getHoursAndMinutes12Hours
} from '../../../Domain/Utils/DateUtilities/DateUtilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderModal from '../../Atoms/HeaderModal/HeaderModal';
import { useTelepresencePurchaseCard } from '../../Organisms/TelepresencePurchaseCard/useTelepresencePurchaseCard';

export const SchedulerCalendar = ({
  isShow,
  handleShow,
  // calendarList,
  zone = '',
  iconZone,
  parameters,
  language,
  schedulerInfo
}) => {
  const { calendarList } = useTelepresencePurchaseCard({
    schedulerInfo,
    language
  });

  return (
    <Modal
      show={isShow && calendarList?.list?.length > 0}
      onHide={() => handleShow(false)}
      centered
      size="lg">
      <HeaderModal
        title={parameters?.PRO_SCHE_LABEL?.value}
        subtitle={parameters?.PRO_SCHE_LABEL?.description_value}
      />
      <Modal.Body>
        <section className="p-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <div className="d-flex  gap-3 mb-3 flex-column flex-lg-row align-items-center justify-content-between">
            {calendarList?.timeZone?.length > 0 && (
              <div className="d-flex gap-2">
                <div>
                  <YellowCircleIcon iconsSvg={iconZone} icon={faEarthAmericas} size="40px" />
                </div>
                <div>
                  <Bold>{parameters?.TIM_ZON_LABEL?.value + ' ' + zone}</Bold>
                  <Paragraph>{calendarList.timeZone}</Paragraph>
                </div>
              </div>
            )}

            {Object.keys(calendarList?.frecuency || []).length > 0 && (
              <div
                className="d-flex gap-2 p-2 border border-dark"
                style={{ background: '#ffe900', border: '' }}>
                <div className="d-flex align-items-center me-2">
                  <FontAwesomeIcon
                    className="mx-auto"
                    icon={faCalendarDays}
                    style={{ fontSize: '20px' }}
                  />
                </div>
                <div className="ps-3" style={{ borderLeft: '2px solid black' }}>
                  <Bold>{calendarList?.frecuency?.name}</Bold>
                </div>
              </div>
            )}
          </div>
          <div>
            {calendarList.list?.map((calendar, index) => (
              <div
                key={index}
                className="border border-dark rounded-2 d-flex gap-2 flex-wrap justify-content-between p-3 mb-3">
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  <YellowCircleIcon icon={faCalendarDays} />
                  <Paragraph>
                    {getFormattedDateMultilanguage(calendar.effective_start_date, false, language)}
                  </Paragraph>
                </div>
                <div className="d-flex flex-wrap gap-3 align-items-center">
                  <YellowCircleIcon icon={faClock} />
                  <Paragraph>
                    {getHoursAndMinutes12Hours(calendar.effective_start_date)} -{' '}
                    {getHoursAndMinutes12Hours(calendar.effective_end_date)}
                  </Paragraph>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};
